export enum BrandCode {
	Celebrity = 'C',
	RoyalCaribbean = 'R',
}

export type ENV = 'tst' | 'tst5' | 'stg' | 'prd';

export type EnvironmentConfig = {
	[key in ENV]: Config;
};

export interface Config {
	endpoints: ConfigEndpoints;
}

export interface ConfigEndpoints {
	cruiseSearchApi: string;
	cruiseSearchTimeout: number;
	aemDictionaries: string;
}

export interface Locale {
	code: string;
	country: string;
	countryAlpha2Code: string;
	currencies: string[];
	currency: string;
	language: string;
	market: string;
	nameCountry: string;
	office: string;
	phoneNumber: string;
	path: string;
}

export const config: EnvironmentConfig = {
	tst: {
		endpoints: {
			cruiseSearchApi: '/graph',
			cruiseSearchTimeout: 20000,
			aemDictionaries: '/bin/services/royal/dictionary',
		},
	},
	tst5: {
		endpoints: {
			cruiseSearchApi: '/graph',
			cruiseSearchTimeout: 20000,
			aemDictionaries: '/bin/services/royal/dictionary',
		},
	},
	stg: {
		endpoints: {
			cruiseSearchApi: '/graph',
			cruiseSearchTimeout: 20000,
			aemDictionaries: '/bin/services/royal/dictionary',
		},
	},
	prd: {
		endpoints: {
			cruiseSearchApi: '/graph',
			cruiseSearchTimeout: 20000,
			aemDictionaries: '/bin/services/royal/dictionary',
		},
	},
};
